import * as React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import { TerminalFilter as TerminalFilterBase } from 'components/ContainerFilters/TerminalFilter';

export const TerminalPickupFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);

  return (
    <TerminalFilterBase
      values={{
        terminals: searchParams.terminalPickupKeys,
        portCodes: searchParams.portPickupCodes,
      }}
      setValues={(values) => {
        setSearchParams({
          terminalPickupKeys: values.terminals,
          portPickupCodes: values.portCodes,
        });
      }}
      onlyTrackNTrace
    />
  );
};
TerminalPickupFilter.displayName = 'TrackAndTrace.Controls.filters.TerminalPickupFilter';
